(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sj-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sj-buy-now')) {
  customElements.define('sj-buy-now', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        this.form = document.getElementById(this.dataset.formId);
        const submit = this.form?.querySelector('button[type="submit"]');
        this.observer?.disconnect();
        if (submit) this.observer?.observe(submit, {attributes:true,attributeFilter:['disabled']});
        window.addEventListener('pageshow',this.restore);
        this.sync();
        return;
      }
      this.ready = true;
      this.hidden = false;
      this.button = this.querySelector('[data-buy-now]');
      this.form = document.getElementById(this.dataset.formId);
      const nativeButton = this.form?.querySelector('button[type="submit"]');
      this.sync = () => {
        const form = document.getElementById(this.dataset.formId);
        const submit = form?.querySelector('button[type="submit"]');
        this.button.disabled = Boolean(!form || this.busy || this.uncertain || this.added || submit?.disabled);
      };
      this.observer = new MutationObserver(this.sync);
      if (nativeButton) this.observer.observe(nativeButton, {attributes:true,attributeFilter:['disabled']});
      this.sync();
      this.restore = (event) => {
        if (event.persisted && !this.busy && !this.uncertain) {
          this.added = false;
          this.querySelector('[role="status"]').hidden = true;
          this.sync();
        }
      };
      window.addEventListener('pageshow',this.restore);
      this.addEventListener('click', async (event) => {
        if (!event.target.closest('[data-buy-now]') || this.busy || this.uncertain || this.added) return;
        const form = document.getElementById(this.dataset.formId);
        const status = this.querySelector('[role="status"]');
        const cartLink = this.querySelector('[data-review-cart]');
        const announce = (text) => { status.hidden = false; status.textContent = text; };
        if (!(form instanceof HTMLFormElement)) {
          announce('Please use Add to Cart, then continue to checkout.');
          return;
        }
        if (!form.reportValidity()) return;
        const submit = form.querySelector('button[type="submit"]');
        if (submit?.disabled || submit?.getAttribute('aria-busy') === 'true' || form.getAttribute('aria-busy') === 'true') {
          announce('Please choose an available option and wait for any cart update to finish.');
          return;
        }
        if (window.sjDirectCheckoutBusy || form.dataset.sjCheckoutBusy === 'true') return;
        const data = new FormData(form);
        const id = String(data.get('id') || '');
        const quantity = Number(data.get('quantity') || 1);
        if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) {
          announce('Please choose a product option and quantity.');
          return;
        }
        this.busy = true;
        window.sjDirectCheckoutBusy = true;
        form.dataset.sjCheckoutBusy = 'true';
        this.sync();
        this.setAttribute('aria-busy','true');
        cartLink.hidden = true;
        announce('Adding your selection and opening checkout…');
        const stopSubmit = (e) => {e.preventDefault();e.stopImmediatePropagation();};
        form.addEventListener('submit',stopSubmit,true);
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(),20000);
        let sent = false;
        let rejected = false;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const addUrl = new URL(root + 'cart/add.js',location.origin);
          const checkoutUrl = new URL(root + 'checkout',location.origin);
          if (addUrl.origin !== location.origin || checkoutUrl.origin !== location.origin) throw new Error('Invalid cart endpoint.');
          sent = true;
          const response = await fetch(addUrl.href,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:data,signal:controller.signal});
          if (!response.ok) {
            rejected = response.status >= 400 && response.status < 500;
            let result = {};
            try { result = await response.json(); } catch (_) {}
            if (!rejected) throw new Error('Cart response uncertain.');
            announce(typeof result.description === 'string' ? result.description : 'This selection could not be added. Please review the product options.');
            return;
          }
          const result = await response.json();
          if (String(result.id || '') !== id) throw new Error('Unexpected cart response.');
          this.added = true;
          // An older incomplete jerky box must be reviewed, not sent to checkout.
          const cartResponse = await fetch(new URL(root + 'cart.js', location.origin), {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal});
          if (!cartResponse.ok) throw new Error('Please review your cart.');
          const currentCart = await cartResponse.json();
          if (!window.SJJerkySelection?.cartIsComplete(currentCart)) {
            location.assign(new URL(root + 'cart', location.origin).href);
            return;
          }
          location.assign(checkoutUrl.href);
        } catch (error) {
          this.uncertain = sent && !rejected && !this.added;
          cartLink.hidden = false;
          announce(this.added ? 'Your selection was added. Continue through your cart.' : 'We could not confirm the update. Review your cart before adding again.');
        } finally {
          clearTimeout(timer);
          form.removeEventListener('submit',stopSubmit,true);
          delete form.dataset.sjCheckoutBusy;
          window.sjDirectCheckoutBusy = false;
          this.removeAttribute('aria-busy');
          this.busy = false;
          this.sync();
        }
      });
    }
    disconnectedCallback() { this.observer?.disconnect(); window.removeEventListener('pageshow',this.restore); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sj-cart-rewards"] && !Shopify.designMode) return;
  try {
    if (!window.sjCartRewardsListener) {
  window.sjCartRewardsListener = true;
  let timer;
  let controller;
  let sequence = 0;
  const refresh = () => {
    clearTimeout(timer);
    const version = ++sequence;
    controller?.abort();
    timer = setTimeout(async () => {
      const targets = Array.from(document.querySelectorAll('sj-cart-rewards'));
      if (!targets.length) return;
      controller = new AbortController();
      targets.forEach((target) => target.setAttribute('aria-busy', 'true'));
      try {
        const url = new URL(targets[0].dataset.cartPath || '/cart', location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid rewards endpoint.');
        url.searchParams.set('section_id', 'sj-cart-rewards');
        const response = await fetch(url.href, {credentials:'same-origin',cache:'no-store',signal:controller.signal});
        if (!response.ok) throw new Error('Rewards refresh failed.');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = doc.querySelector('sj-cart-rewards');
        if (!updated) throw new Error('Rewards section missing.');
        if (version !== sequence) return;
        document.querySelectorAll('sj-cart-rewards').forEach((target) => {
          target.innerHTML = updated.innerHTML;
          target.removeAttribute('aria-busy');
        });
      } catch (error) {
        if (error.name === 'AbortError' || version !== sequence) return;
        document.querySelectorAll('sj-cart-rewards').forEach((target) => {
          target.textContent = 'Your latest shipping and savings totals will be confirmed at checkout.';
          target.removeAttribute('aria-busy');
        });
      }
    }, 120);
  };
  document.addEventListener('cart:change', refresh);
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
}
  } catch(e) { console.error(e); }
})();

})();
